const FACULTY_STATS_SECTIONS = [
  "articlePublications",
  "textBookPublications",
  "patents",
  "copyrights",
  "fellowships",
  "phd",
  "swayamCourses",
  "awards",
  "innovativeTeaching",
  "eContent",
  "researchGrants",
  "guestLectures",
  "conferencePresentation",
  "shortResearchProjects"
];

export async function fetchAllFacultyStats(facultyList, apiGet) {
  const results = await Promise.all(
    facultyList.map(async (faculty) => {
      const sectionCounts = {};
      const sectionData = await Promise.all(
        FACULTY_STATS_SECTIONS.map(async (key) => {
          try {
            const data = await apiGet(`/faculty/${faculty.id}/section/${key}`);
            return { key, count: Array.isArray(data) ? data.length : 0 };
          } catch {
            return { key, count: 0 };
          }
        })
      );
      sectionData.forEach(({ key, count }) => {
        sectionCounts[key] = count;
      });
      return {
        id: faculty.id,
        ...sectionCounts,
        total: Object.values(sectionCounts).reduce((a, b) => a + b, 0)
      };
    })
  );
  return results;
}

export { FACULTY_STATS_SECTIONS };
